import { useDispatch, useSelector } from 'react-redux';
import { selectEligibleOffers, selectUnlockedOffers, setOffers } from '../../../../store/slices/OfferSlice';
import useGetBasketOfferHandlerByKind from '../get-offer-handler/useGetBasketOfferHandlerByKind';
import { Offer } from '../../../../services/exports/Interfaces';
import { useEffect } from 'react';
import { CompleteBasketItem } from '../../../../providers/BasketProvider';
import useGetCompanyMenusApi from '../../../../hooks/api/companies/useGetCompanyMenusApi';
import { haveSameOffers } from '../../utils';

const useWatchEligibleOffers = (items: CompleteBasketItem[]) => {
  const eligibleOffers = useSelector(selectEligibleOffers);
  const unlockedOffers = useSelector(selectUnlockedOffers);
  const dispatch = useDispatch();
  const { data } = useGetCompanyMenusApi();
  const offerHandler = useGetBasketOfferHandlerByKind();
  const setEligibleOffers = (offers: Offer[] = []) => {
    // Compare, don't just check for empty. Dispatching an equal-but-new array installs a new
    // reference (setOffers is a bare Object.assign), which re-runs useAutoApplyBestOffer, which
    // re-writes appliedOffers, which recomputes BasketProvider's `items` — closing a render loop
    // for any offer that stays applied. See haveSameOffers.
    if (haveSameOffers(offers, eligibleOffers)) {
      return;
    }

    dispatch(setOffers({ eligibleOffers: offers }));
  };

  const unlockedOffersHandler = (): void => {
    const result = unlockedOffers.filter((offer) => offerHandler(offer, items).isEligible);

    setEligibleOffers(result);
  };

  useEffect(() => {
    if (!data) {
      return;
    }

    unlockedOffersHandler();
  }, [unlockedOffers, items, data]);
};

export default useWatchEligibleOffers;
